// CRDBAG CUSTOM CODE

// CRDBAG - CART

// VAT
document.addEventListener("DOMContentLoaded", function () {
  // Lista över EU-länder där VAT kan dras av
  const euVatCountries = [
    "AT", // Austria
    "BE", // Belgium
    "BG", // Bulgaria
    "HR", // Croatia
    "CY", // Cyprus
    "CZ", // Czech Republic
    "DK", // Denmark
    "EE", // Estonia
    "FI", // Finland
    "FR", // France
    "DE", // Germany
    "GR", // Greece
    "HU", // Hungary
    "IE", // Ireland
    "IT", // Italy
    "LV", // Latvia
    "LT", // Lithuania
    "LU", // Luxembourg
    "MT", // Malta
    "NL", // Netherlands
    "PL", // Poland
    "PT", // Portugal
    "RO", // Romania
    "SK", // Slovakia
    "SI", // Slovenia
    "ES", // Spain
    "SE", // Sweden
  ];

  // Hämta användarens land från Shopify
  const userCountry = Shopify.country;

  // VAT-blockets element
  const vatBlock = document.getElementById("ExemptifyCartValidationSnippet");

  // Kontrollera om användarens land är i listan och visa blocket
  if (euVatCountries.includes(userCountry)) {
    vatBlock.style.display = "block";
  }
});



// CUSTOMS INFO
document.addEventListener("DOMContentLoaded", function () {
  // Hämta alla offer-block i rätt ordning
  const offerBlocks = document.querySelectorAll(".v-stack > div.offer");

  // Kontrollera att båda blocken finns
  if (offerBlocks.length < 2) {
    console.error("Ett eller båda blocken kunde inte hittas.");
    return;
  }

  // Definiera blocken
  const ukOffer = offerBlocks[0]; // Första blocket (UK)
  const euOffer = offerBlocks[1]; // Andra blocket (EU och Norden)

  // Dölj båda blocken som standard
  ukOffer.style.display = "none";
  euOffer.style.display = "none";

  // Lista över specifika länder för EU-blocket
  const euCountries = [
    "NO", // Norge
    "IS", // Island
    "FO", // Färöarna
    "GL", // Grönland
    "CH", // Schweiz
    "LI", // Liechtenstein
    "AD", // Andorra
    "SM", // San Marino
    "MC", // Monaco
    "VA", // Vatikanstaten
  ];

  // Hämta valt land från Shopify
  const selectedCountry = Shopify.country;

  // Visa UK-blocket för UK
  if (selectedCountry === "GB") {
    ukOffer.style.display = "block";
  }

  // Visa EU-blocket för specificerade länder
  if (euCountries.includes(selectedCountry)) {
    euOffer.style.display = "block";
  }
});

// CRDBAG - AUTO NEXT
document.addEventListener('DOMContentLoaded', () => {
  // Select the content carousel and image carousel elements
  const contentCarousel = document.querySelector('multiple-images-with-text-content-list');
  const imageCarousel = document.querySelector('multiple-images-with-text-image-list');

  if (contentCarousel && imageCarousel) {
    // Function to trigger the next slide
    const goToNextSlide = () => {
      imageCarousel.next();
      contentCarousel.next();
    };

    // Set an interval to change slides every 5 seconds
    const autoSlideInterval = setInterval(goToNextSlide, 5000);

    // Stop auto-sliding if the user interacts with the navigation buttons
    const prevButton = document.querySelector('button[is="prev-button"]');
    const nextButton = document.querySelector('button[is="next-button"]');

    const stopAutoSliding = () => clearInterval(autoSlideInterval);

    prevButton?.addEventListener('click', stopAutoSliding);
    nextButton?.addEventListener('click', stopAutoSliding);

    // Debug log
    console.log('Auto-sliding activated for multiple-images-with-text block.');
  } else {
    console.warn('Multiple-images-with-text carousels not found.');
  }
});


// CRDBAG - AUTOSCROLL LANDING
document.addEventListener("DOMContentLoaded", function () {
  // Select the existing carousel
  const carousel = document.querySelector("#carousel-template--25031340982614__text_with_icons_zAXAmg");
  

  if (!carousel) return;

  // Auto-scroll configuration
  const autoScrollDelay = 2000; // Delay in milliseconds
  let autoScrollInterval = null;

  function initializeAutoScroll() {
    const scrollCarouselInstance = carousel.__carouselInstance || carousel;

    if (!scrollCarouselInstance.items || scrollCarouselInstance.items.length === 0) {
      // Retry if the carousel instance or items are not ready
      setTimeout(initializeAutoScroll, 100);
      return;
    }

    function startAutoScroll() {
      if (autoScrollInterval) return; // Prevent duplicate intervals

      autoScrollInterval = setInterval(() => {
        const nextIndex = (scrollCarouselInstance.selectedIndex + 1) % scrollCarouselInstance.items.length;
        scrollCarouselInstance.select(nextIndex);
      }, autoScrollDelay);
    }

    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }

    // Start auto-scroll
    startAutoScroll();

    // Optional: Stop auto-scroll when the tab is hidden
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoScroll();
      } else {
        startAutoScroll();
      }
    });
  }

  // Wait for the carousel to initialize
  initializeAutoScroll();
});

// CRDBAG - AUTOSCROLL PRODUCT
document.addEventListener("DOMContentLoaded", function () {
  // Select the existing carousel
  const carousel = document.querySelector("#carousel-template--24391665582422__text_with_icons_zAXAmg");

  if (!carousel) return;

  // Auto-scroll configuration
  const autoScrollDelay = 2000; // Delay in milliseconds
  let autoScrollInterval = null;

  function initializeAutoScroll() {
    const scrollCarouselInstance = carousel.__carouselInstance || carousel;

    if (!scrollCarouselInstance.items || scrollCarouselInstance.items.length === 0) {
      // Retry if the carousel instance or items are not ready
      setTimeout(initializeAutoScroll, 100);
      return;
    }

    function startAutoScroll() {
      if (autoScrollInterval) return; // Prevent duplicate intervals

      autoScrollInterval = setInterval(() => {
        const nextIndex = (scrollCarouselInstance.selectedIndex + 1) % scrollCarouselInstance.items.length;
        scrollCarouselInstance.select(nextIndex);
      }, autoScrollDelay);
    }

    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }

    // Start auto-scroll
    startAutoScroll();

    // Optional: Stop auto-scroll when the tab is hidden
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoScroll();
      } else {
        startAutoScroll();
      }
    });
  }

  // Wait for the carousel to initialize
  initializeAutoScroll();
});



